const en_master_whs_setting = {
    "": "warehouse setting",
    add: "add warehouse",
    edit: "edit warehouse",
    name: "warehouse name",
}

export default en_master_whs_setting;